export default "__VITE_ASSET__6485b53b__"